import React, { useState, useEffect } from "react";
import config, {
  CREATEPACKAGESIGHT,
} from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import moment from "moment";
import "./PackageForm.css"

const PackageSightSeeing = ({ packageId }) => {
  const initialFieldValues = {
    packageSightSeeingId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    date: "",
    destination: "",
    sightseeingName: "",
    description: "",
    price: "" 
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [data, setData] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);


  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit]);

  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETSIGHTBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
    setData(res.data);
  };
const handleAddNewClick = () => {
    resetForm();
    setIsFormVisible(true);
  };
  
  const showEditDetails = (data) => {
    const formattedData = {
        ...data,
        date: moment(data.date).format('YYYY-MM-DDTHH:mm'),
    };
    setRecordForEdit(formattedData);
    setValues(formattedData);
    setIsFormVisible(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGESIGHT, itemToDelete);
        await GetData();
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.date = values.date === "" ? false : true;
    temp.destination = values.destination === "" ? false : true;
    temp.sightseeingName = values.sightseeingName === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageSightSeeingId: values.packageSightSeeingId,
        packageId: packageId,
        date: values.date,
        destination: values.destination,
        sightseeingName: values.sightseeingName,
        description: values.description,
        userId: user?.id,
        price: values.price, 
      };
      console.log("Submitting form data:", formData);
      try {
        const isNew =
          formData.packageSightSeeingId ===
          "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGESIGHT, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGESIGHT, formData);
        }
        await GetData();
        resetForm();
        setIsFormVisible(false); 
      } finally {
        setBtnLoading(false);
      }
    }
  };
  const handleCancel = () => {
    resetForm();
    setIsFormVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setRecordForEdit(null);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);

  return (
    <div className="PackageSightseeing-wrapper">
      <div className="card PackageSightseeing-card">
        <div className="card-body">
          <div className="PackageSightseeing-header">
            <h4 className="header-title">Sightseeing Activities</h4>
            {!isFormVisible && (
              <button
                type="button"
                className="btn btn-primary PackageSightseeing-btn-gradient"
                onClick={handleAddNewClick}
              >
                <i className="ri-add-line me-1"></i> Add Activity
              </button>
            )}
          </div>
          {isFormVisible && (
            <div className="PackageSightseeing-form-container">
              <h5 className="form-title">
                {values.packageSightSeeingId === "00000000-0000-0000-0000-000000000000"
                  ? "Add Activity Details"
                  : "Edit Activity Details"}
              </h5>
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-camera-lens-line me-2"></i>Activity Name</label>
                      <input type="text" name="sightseeingName" value={values.sightseeingName} onChange={handleInputChange} className={"form-control" + applyErrorClass("sightseeingName")} placeholder="e.g. Burj Khalifa Tour"/>
                      {errors.sightseeingName === false && <div className="validationerror">Please enter a valid activity name</div>}
                  </div>
                   <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-map-pin-line me-2"></i>Destination / City</label>
                      <input type="text" name="destination" value={values.destination} onChange={handleInputChange} className={"form-control" + applyErrorClass("destination")} placeholder="e.g. Dubai"/>
                      {errors.destination === false && <div className="validationerror">Please enter a valid destination</div>}
                  </div>

                  <div className="col-lg-3 mb-3">
                       <label className="form-label d-flex align-items-center"><i className="ri-calendar-event-line me-2"></i>Date & Time</label>
                       <input type="datetime-local" name="date" value={values.date} onChange={handleInputChange} className={"form-control" + applyErrorClass("date")}/>
                        {errors.date === false && <div className="validationerror">Please select a valid date and time</div>}
                  </div>
                  <div className="col-lg-3 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-money-dollar-circle-line me-2"></i>Price</label>
                      <input type="number" name="price" value={values.price} onChange={handleInputChange} className={"form-control"} placeholder="e.g. 150"/>
                  </div>
                  <div className="col-lg-12 mb-3">
                      <label className="form-label d-flex align-items-center"><i className="ri-file-text-line me-2"></i>Description</label>
                      <textarea name="description" value={values.description} onChange={handleInputChange} className={"form-control"} placeholder="Add notes or details about the activity..." rows="3"></textarea>
                  </div>

                </div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={btnLoading}>
                        {btnLoading ? "Saving..." : (values.packageSightSeeingId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update")}
                    </button>
                </div>
              </form>
            </div>
          )}
          <div className="mt-4">
            {lists.length > 0 ? (
              <div className="PackageSightseeing-list">
                {lists.map((v) => (
                  <div key={v.packageSightSeeingId} className="PackageSightseeing-list-item">
                    <div className="item-icon">
                      <i className="ri-camera-lens-line"></i>
                    </div>
                    <div className="item-content">
                        <div className="item-header">
                            <h6 className="item-title">{v.sightseeingName}</h6>
                             <h6 className="item-price">{`INR ${v.price}`}</h6>
                        </div>
                        <p className="item-description">{v.description || 'No description provided.'}</p>
                       <div className="item-destination d-flex align-items-center">
  <i className="ri-map-pin-2-fill me-1"></i>
  <span>{v.destination}</span>
    
  <div className="item-date ms-3 d-flex align-items-center">
    <i className="ri-calendar-todo-line me-2"></i>
    {moment(v.date).format("ddd, DD MMM YYYY")}
  </div>
</div>

                        
                    </div>
                    <div className="item-actions">
                        <button className="PackageSightseeing-action-btn edit" onClick={() => showEditDetails(v)}><i className="ri-pencil-fill"/></button>
                        <button className="PackageSightseeing-action-btn delete" onClick={() => handleOpenDeleteModal(v.packageSightSeeingId)}><i className="ri-delete-bin-fill"/></button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
                <div className="PackageSightseeing-empty-state">
                    <i className="ri-compass-3-line empty-icon"></i>
                    <h5>No Sightseeing Activities Added</h5>
                    <p>Click "Add Activity" to include tours and attractions.</p>
                </div>
            )}
          </div>
        </div>
      </div>
      <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
    </div>
  );
};

export default PackageSightSeeing;